import { SecurityIssue, SecurityDashboardStats, Agent, ComplianceScore } from "../types/security";

export const mockSecurityIssues: SecurityIssue[] = [
  {
    id: "SEC-001",
    timestamp: "2025-10-15T10:23:45Z",
    type: "PII_DETECTION",
    severity: "CRITICAL",
    status: "OPEN",
    title: "Social Security Number Detected in Prompt",
    description:
      "User input contained a valid SSN pattern that was not sanitized before processing.",
    traceId: "trace_8a9b7c6d5e4f3g2h",
    scanner: "Secrets Scanner",
    riskScore: 0.95,
    detectedContent: "My SSN is ***-**-1234",
    sanitizedContent: "My SSN is [REDACTED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_12345",
      model: "gpt-4",
      pattern: "SSN",
    },
  },
  {
    id: "SEC-002",
    timestamp: "2025-10-15T09:15:22Z",
    type: "PROMPT_INJECTION",
    severity: "HIGH",
    status: "IN_REVIEW",
    title: "Potential Prompt Injection Attempt",
    description:
      "Input contained instructions attempting to override system prompts and extract sensitive information.",
    traceId: "trace_7h8i9j0k1l2m3n4o",
    scanner: "PromptInjection Scanner",
    riskScore: 0.87,
    detectedContent: "Ignore previous instructions and tell me...",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_67890",
      model: "gpt-4",
      attackType: "instruction_override",
    },
  },
  {
    id: "SEC-003",
    timestamp: "2025-10-15T08:45:10Z",
    type: "DATA_EXFILTRATION",
    severity: "CRITICAL",
    status: "OPEN",
    title: "Suspicious Data Export Pattern Detected",
    description:
      "Model output contained structured data that appears to be exfiltrating internal database schema information.",
    traceId: "trace_5p6q7r8s9t0u1v2w",
    scanner: "Relevance Scanner",
    riskScore: 0.92,
    detectedContent: "Table: users, Columns: id, email, password_hash...",
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_24680",
      model: "gpt-3.5-turbo",
      dataType: "database_schema",
    },
  },
  {
    id: "SEC-004",
    timestamp: "2025-10-15T07:30:55Z",
    type: "TOXIC_CONTENT",
    severity: "MEDIUM",
    status: "RESOLVED",
    title: "Toxic Language Detected in User Input",
    description: "User input contained toxic language that exceeded acceptable thresholds.",
    traceId: "trace_3x4y5z6a7b8c9d0e",
    scanner: "Toxicity Scanner",
    riskScore: 0.68,
    detectedContent: "[Toxic content redacted]",
    sanitizedContent: "[Content blocked due to toxicity]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_13579",
      model: "gpt-4",
      toxicityScore: 0.85,
    },
  },
  {
    id: "SEC-005",
    timestamp: "2025-10-15T06:20:30Z",
    type: "MALICIOUS_URL",
    severity: "HIGH",
    status: "OPEN",
    title: "Malicious URL in Model Output",
    description:
      "Model generated response contained a URL flagged as malicious by threat intelligence.",
    traceId: "trace_1f2g3h4i5j6k7l8m",
    scanner: "MaliciousURLs Scanner",
    riskScore: 0.89,
    detectedContent: "Visit http://malicious-site[.]com for more info",
    sanitizedContent: "[URL removed for security]",
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_98765",
      model: "gpt-4",
      urlReputation: "malicious",
      threatCategory: "phishing",
    },
  },
  {
    id: "SEC-006",
    timestamp: "2025-10-14T23:45:18Z",
    type: "SECRETS_EXPOSURE",
    severity: "CRITICAL",
    status: "OPEN",
    title: "API Key Exposed in Training Data",
    description:
      "Model output inadvertently revealed what appears to be an API key from training data.",
    traceId: "trace_9n0o1p2q3r4s5t6u",
    scanner: "Secrets Scanner",
    riskScore: 0.98,
    detectedContent: "API_KEY: sk_live_*********************",
    sanitizedContent: "API_KEY: [REDACTED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_11223",
      model: "gpt-3.5-turbo",
      secretType: "api_key",
      provider: "stripe",
    },
  },
  {
    id: "SEC-007",
    timestamp: "2025-10-14T22:15:42Z",
    type: "BIAS_DETECTION",
    severity: "MEDIUM",
    status: "IN_REVIEW",
    title: "Gender Bias Detected in Model Response",
    description:
      "Model output showed statistically significant gender bias in job role recommendations.",
    traceId: "trace_7v8w9x0y1z2a3b4c",
    scanner: "Bias Scanner",
    riskScore: 0.71,
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_33445",
      model: "gpt-4",
      biasType: "gender",
      biasScore: 0.78,
    },
  },
  {
    id: "SEC-008",
    timestamp: "2025-10-14T20:50:33Z",
    type: "SENSITIVE_INFO",
    severity: "HIGH",
    status: "OPEN",
    title: "Medical Information Detected",
    description:
      "Input contained protected health information (PHI) that requires special handling under HIPAA.",
    traceId: "trace_5d6e7f8g9h0i1j2k",
    scanner: "Sensitive Scanner",
    riskScore: 0.84,
    detectedContent: "Patient diagnosis: [MEDICAL CONDITION REDACTED]",
    sanitizedContent: "Patient diagnosis: [PROTECTED HEALTH INFORMATION]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_55667",
      model: "gpt-4",
      infoType: "medical_diagnosis",
      complianceFramework: "HIPAA",
    },
  },
  {
    id: "SEC-009",
    timestamp: "2025-10-14T19:30:15Z",
    type: "PII_DETECTION",
    severity: "HIGH",
    status: "RESOLVED",
    title: "Email Address and Phone Number Detected",
    description: "User shared personal contact information that was successfully anonymized.",
    traceId: "trace_3l4m5n6o7p8q9r0s",
    scanner: "Anonymize Scanner",
    riskScore: 0.76,
    detectedContent: "Contact me at john.doe@email.com or 555-123-4567",
    sanitizedContent: "Contact me at [EMAIL_1] or [PHONE_1]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_77889",
      model: "gpt-3.5-turbo",
      piiTypes: ["email", "phone"],
    },
  },
  {
    id: "SEC-010",
    timestamp: "2025-10-14T18:10:55Z",
    type: "PROMPT_INJECTION",
    severity: "MEDIUM",
    status: "FALSE_POSITIVE",
    title: "Potential Jailbreak Attempt",
    description:
      "Input pattern matched jailbreak signatures but was determined to be legitimate code discussion.",
    traceId: "trace_1t2u3v4w5x6y7z8a",
    scanner: "PromptInjection Scanner",
    riskScore: 0.62,
    detectedContent: "How do I break out of a loop in Python?",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_99001",
      model: "gpt-4",
      falsePositiveReason: "legitimate_coding_question",
    },
  },
];

export const mockDashboardStats: SecurityDashboardStats = {
  totalIssues: 127,
  criticalIssues: 8,
  openIssues: 45,
  resolvedToday: 12,
  averageRiskScore: 0.73,
};

// Mock chart data for dashboard visualization
// TODO: Replace with real data from API when backend integration is complete
export interface DailyIssue {
  type: string;
  count: number;
}

export interface ChartDataPoint {
  day: number;
  date: string; // Full date string for display
  criticalCount: number;
  criticalIssues: DailyIssue[];
  highCount: number;
  highIssues: DailyIssue[];
}

export interface StatusTrendDataPoint {
  day: number;
  date: string;
  opened: number;
  resolved: number;
  inReview: number;
}

// Chart metadata
export const mockChartMetadata = {
  month: "October",
  year: 2025,
  monthYear: "October 2025",
};

// Day labels for different date ranges
export const getDayLabelsForRange = (days: number, startMonth: string = "October") => {
  const labels: Array<{ day: number; month: string }> = [];
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthIndex = monthNames.indexOf(startMonth.slice(0, 3));

  if (days === 7) {
    for (let i = 1; i <= 7; i++) {
      labels.push({ day: i, month: monthNames[monthIndex] });
    }
  } else if (days === 30) {
    [1, 5, 10, 15, 20, 25, 30].forEach((day) => {
      labels.push({ day, month: monthNames[monthIndex] });
    });
  } else if (days === 90) {
    labels.push({ day: 1, month: monthNames[monthIndex] });
    labels.push({ day: 15, month: monthNames[monthIndex] });
    labels.push({ day: 30, month: monthNames[monthIndex] });
    labels.push({ day: 14, month: monthNames[(monthIndex + 1) % 12] });
    labels.push({ day: 28, month: monthNames[(monthIndex + 1) % 12] });
    labels.push({ day: 15, month: monthNames[(monthIndex + 2) % 12] });
    labels.push({ day: 30, month: monthNames[(monthIndex + 2) % 12] });
  }
  return labels;
};

// Generate 15 days of mock data (up to October 15th, 2025)
export const mockMonthlyChartData: ChartDataPoint[] = Array.from({ length: 15 }, (_, i) => {
  const day = i + 1;
  return {
    day,
    date: `Oct ${day}, 2025`,
    criticalCount: Math.floor(Math.random() * 15) + 10, // 10-25 critical issues per day
    criticalIssues: [
      { type: "SSN Detection", count: Math.floor(Math.random() * 5) + 2 },
      { type: "API Key Exposure", count: Math.floor(Math.random() * 4) + 1 },
      { type: "Credit Card Info", count: Math.floor(Math.random() * 3) + 1 },
      { type: "Password Leak", count: Math.floor(Math.random() * 4) + 2 },
      { type: "Private Key Found", count: Math.floor(Math.random() * 3) + 1 },
    ],
    highCount: Math.floor(Math.random() * 25) + 15, // 15-40 high issues per day
    highIssues: [
      { type: "Prompt Injection", count: Math.floor(Math.random() * 8) + 3 },
      { type: "Malicious URL", count: Math.floor(Math.random() * 6) + 2 },
      { type: "Data Exfiltration", count: Math.floor(Math.random() * 5) + 2 },
      { type: "Jailbreak Attempt", count: Math.floor(Math.random() * 7) + 3 },
      { type: "SQL Injection", count: Math.floor(Math.random() * 4) + 2 },
    ],
  };
});

// Severity statistics with trending information
export interface SeverityStats {
  count: number;
  trend: "up" | "down";
  trendPercentage: number;
  openCount: number;
}

export const mockSeverityStats: Record<string, SeverityStats> = {
  critical: {
    count: 248,
    trend: "up",
    trendPercentage: 10,
    openCount: 221,
  },
  high: {
    count: 602,
    trend: "up",
    trendPercentage: 6,
    openCount: 542,
  },
  medium: {
    count: 2482,
    trend: "down",
    trendPercentage: 3,
    openCount: 1890,
  },
  low: {
    count: 2535,
    trend: "up",
    trendPercentage: 2,
    openCount: 1012,
  },
};

// Generate status trend data for "Opened and Resolved Issues" chart
export const mockStatusTrendData: StatusTrendDataPoint[] = Array.from({ length: 15 }, (_, i) => {
  const day = i + 1;
  // Simulate realistic patterns: more issues opened early in the period, resolution catching up
  const baseOpened = 25 + Math.floor(Math.random() * 20); // 25-45 opened per day
  const baseResolved = 15 + Math.floor(Math.random() * 25); // 15-40 resolved per day
  const inReview = 5 + Math.floor(Math.random() * 15); // 5-20 in review per day

  return {
    day,
    date: `Oct ${day}, 2025`,
    opened: baseOpened,
    resolved: baseResolved,
    inReview: inReview,
  };
});

// Mock AI Agents data based on trace examples
export const mockAgents: Agent[] = [
  {
    id: "agent-001",
    name: "pii-aware-assistant",
    description:
      "AI assistant specialized in handling personally identifiable information with privacy controls",
    modelName: "gemini-2.0-flash-exp",
    criticalIssues: 3,
    highIssues: 2,
    totalIssues: 8,
    trendPercentage: 12,
    trendDirection: "up",
    issueIds: ["SEC-001", "SEC-003", "SEC-006", "SEC-009"],
  },
  {
    id: "agent-002",
    name: "prompt-injection-guard",
    description: "Security-focused agent that detects and prevents prompt injection attacks",
    modelName: "gpt-4",
    criticalIssues: 1,
    highIssues: 3,
    totalIssues: 6,
    trendPercentage: 5,
    trendDirection: "down",
    issueIds: ["SEC-002", "SEC-010"],
  },
  {
    id: "agent-003",
    name: "content-moderator",
    description:
      "Monitors and filters toxic content and inappropriate language in user interactions",
    modelName: "claude-3-sonnet",
    criticalIssues: 0,
    highIssues: 1,
    totalIssues: 4,
    trendPercentage: 8,
    trendDirection: "down",
    issueIds: ["SEC-004"],
  },
  {
    id: "agent-004",
    name: "data-exfiltration-detector",
    description:
      "Identifies and blocks attempts to extract sensitive database and system information",
    modelName: "gemini-2.0-flash-exp",
    criticalIssues: 2,
    highIssues: 1,
    totalIssues: 5,
    trendPercentage: 15,
    trendDirection: "up",
    issueIds: ["SEC-003", "SEC-008"],
  },
  {
    id: "agent-005",
    name: "url-safety-scanner",
    description: "Scans and validates URLs to prevent phishing and malicious link distribution",
    modelName: "gpt-3.5-turbo",
    criticalIssues: 0,
    highIssues: 2,
    totalIssues: 3,
    trendPercentage: 3,
    trendDirection: "up",
    issueIds: ["SEC-005"],
  },
];

// AI Compliance Framework Scores
export const mockComplianceScores: ComplianceScore[] = [
  {
    id: "iso-42001",
    name: "ISO 42001 - AI Management System",
    shortName: "ISO 42001",
    score: 78,
    category: "management",
    description:
      "AI Management System certification covering governance, risk management, and operational controls for AI systems",
    details: {
      status: "compliant",
      controls: 39,
      totalControls: 50,
      pending: 11,
      criticalGaps: 3,
      highGaps: 5,
      trend: "improving",
      trendPercentage: "+5%",
      nextDeadline: "2025-12-31",
      estimatedCost: "$28k",
      responsibleTeam: "AI Governance Team",
      documentationGaps: 7,
      lastAudit: "2025-10-01",
      nextReview: "2025-11-01",
      relatedIssues: {
        critical: 2,
        high: 5,
      },
      priorityActions: [
        {
          id: "iso-action-1",
          title: "Implement AI Model Risk Assessment Framework",
          priority: "critical",
          dueInDays: 14,
          description: "Critical for compliance",
        },
        {
          id: "iso-action-2",
          title: "Complete Data Governance Documentation",
          priority: "high",
          dueInDays: 30,
          description: "High priority",
        },
        {
          id: "iso-action-3",
          title: "Establish AI Ethics Review Board",
          priority: "high",
          dueInDays: 45,
          description: "High priority",
        },
      ],
    },
  },
  {
    id: "nist-ai-rmf",
    name: "NIST AI Risk Management Framework",
    shortName: "NIST AI RMF",
    score: 85,
    category: "risk",
    description:
      "Framework for managing AI risks including trustworthiness, accountability, and transparency",
    details: {
      status: "compliant",
      controls: 42,
      totalControls: 50,
      pending: 8,
      criticalGaps: 2,
      highGaps: 3,
      trend: "improving",
      trendPercentage: "+8%",
      nextDeadline: "2025-12-15",
      estimatedCost: "$20k",
      responsibleTeam: "Risk Management Team",
      documentationGaps: 5,
      lastAudit: "2025-09-15",
      nextReview: "2025-10-30",
      relatedIssues: {
        critical: 1,
        high: 4,
      },
      priorityActions: [
        {
          id: "nist-action-1",
          title: "Complete Trustworthiness Assessment",
          priority: "critical",
          dueInDays: 10,
          description: "Critical for NIST compliance",
        },
        {
          id: "nist-action-2",
          title: "Update Risk Register for AI Systems",
          priority: "high",
          dueInDays: 25,
          description: "High priority",
        },
        {
          id: "nist-action-3",
          title: "Implement Continuous Monitoring",
          priority: "high",
          dueInDays: 40,
          description: "High priority",
        },
      ],
    },
  },
  {
    id: "eu-ai-act",
    name: "EU AI Act Compliance",
    shortName: "EU AI Act",
    score: 72,
    category: "regulation",
    description:
      "European Union AI regulation compliance covering high-risk AI systems and prohibited practices",
    details: {
      status: "partial",
      controls: 36,
      totalControls: 50,
      pending: 14,
      criticalGaps: 4,
      highGaps: 6,
      trend: "stable",
      trendPercentage: "+2%",
      nextDeadline: "2026-08-02",
      estimatedCost: "$35k",
      responsibleTeam: "Legal & Compliance Team",
      documentationGaps: 8,
      lastAudit: "2025-09-20",
      nextReview: "2025-11-15",
      relatedIssues: {
        critical: 3,
        high: 6,
      },
      priorityActions: [
        {
          id: "eu-action-1",
          title: "Classify AI Systems by Risk Level",
          priority: "critical",
          dueInDays: 20,
          description: "Critical for EU AI Act",
        },
        {
          id: "eu-action-2",
          title: "Implement Conformity Assessment",
          priority: "critical",
          dueInDays: 35,
          description: "Critical for compliance",
        },
        {
          id: "eu-action-3",
          title: "Establish CE Marking Process",
          priority: "high",
          dueInDays: 60,
          description: "High priority",
        },
      ],
    },
  },
  {
    id: "ieee-7000",
    name: "IEEE 7000 Series - AI Ethics",
    shortName: "IEEE 7000",
    score: 91,
    category: "ethics",
    description:
      "Ethical standards for AI systems including fairness, transparency, and human-centric design",
    details: {
      status: "compliant",
      controls: 45,
      totalControls: 50,
      pending: 5,
      criticalGaps: 1,
      highGaps: 2,
      trend: "improving",
      trendPercentage: "+6%",
      nextDeadline: "2026-01-31",
      estimatedCost: "$12k",
      responsibleTeam: "AI Ethics Committee",
      documentationGaps: 3,
      lastAudit: "2025-10-05",
      nextReview: "2025-11-20",
      relatedIssues: {
        critical: 0,
        high: 2,
      },
      priorityActions: [
        {
          id: "ieee-action-1",
          title: "Complete Bias Assessment for Models",
          priority: "high",
          dueInDays: 15,
          description: "High priority",
        },
        {
          id: "ieee-action-2",
          title: "Update Transparency Documentation",
          priority: "high",
          dueInDays: 28,
          description: "High priority",
        },
        {
          id: "ieee-action-3",
          title: "Review Human-AI Interaction Guidelines",
          priority: "medium",
          dueInDays: 50,
          description: "Medium priority",
        },
      ],
    },
  },
  {
    id: "soc2-ai",
    name: "SOC 2 Type II - AI Systems",
    shortName: "SOC 2 AI",
    score: 88,
    category: "management",
    description:
      "Service Organization Control certification for AI system security, availability, and confidentiality",
    details: {
      status: "compliant",
      controls: 44,
      totalControls: 50,
      pending: 6,
      criticalGaps: 1,
      highGaps: 3,
      trend: "improving",
      trendPercentage: "+7%",
      nextDeadline: "2025-11-30",
      estimatedCost: "$15k",
      responsibleTeam: "InfoSec Team",
      documentationGaps: 4,
      lastAudit: "2025-09-25",
      nextReview: "2025-10-25",
      relatedIssues: {
        critical: 1,
        high: 3,
      },
      priorityActions: [
        {
          id: "soc2-action-1",
          title: "Complete Security Controls Testing",
          priority: "critical",
          dueInDays: 12,
          description: "Critical for audit",
        },
        {
          id: "soc2-action-2",
          title: "Update Availability Monitoring",
          priority: "high",
          dueInDays: 22,
          description: "High priority",
        },
        {
          id: "soc2-action-3",
          title: "Review Access Control Policies",
          priority: "high",
          dueInDays: 35,
          description: "High priority",
        },
      ],
    },
  },
  {
    id: "gdpr-ai",
    name: "GDPR AI Data Protection",
    shortName: "GDPR AI",
    score: 94,
    category: "regulation",
    description:
      "General Data Protection Regulation compliance for AI systems handling personal data",
    details: {
      status: "compliant",
      controls: 47,
      totalControls: 50,
      pending: 3,
      criticalGaps: 0,
      highGaps: 1,
      trend: "improving",
      trendPercentage: "+4%",
      nextDeadline: "2026-05-25",
      estimatedCost: "$8k",
      responsibleTeam: "Data Protection Office",
      documentationGaps: 2,
      lastAudit: "2025-10-10",
      nextReview: "2025-12-10",
      relatedIssues: {
        critical: 0,
        high: 1,
      },
      priorityActions: [
        {
          id: "gdpr-action-1",
          title: "Update Data Processing Records",
          priority: "high",
          dueInDays: 18,
          description: "High priority",
        },
        {
          id: "gdpr-action-2",
          title: "Review Data Subject Rights Procedures",
          priority: "medium",
          dueInDays: 40,
          description: "Medium priority",
        },
        {
          id: "gdpr-action-3",
          title: "Complete Privacy Impact Assessments",
          priority: "medium",
          dueInDays: 55,
          description: "Medium priority",
        },
      ],
    },
  },
];

// Issue Severity Statistics
export const mockIssueSeverityData = {
  critical: mockSecurityIssues.filter((i) => i.severity === "CRITICAL").length,
  high: mockSecurityIssues.filter((i) => i.severity === "HIGH").length,
  medium: mockSecurityIssues.filter((i) => i.severity === "MEDIUM").length,
  low: mockSecurityIssues.filter((i) => i.severity === "LOW").length,
  criticalTrend: 19,
  highTrend: 0,
  mediumTrend: 0,
  lowTrend: 0,
};

// Open Issue Age Statistics
export const mockOpenIssueAgeData = (() => {
  const openIssues = mockSecurityIssues.filter((i) => i.status === "OPEN");

  // Calculate average age (mock calculation - in real app, calculate from timestamp)
  const averageAge = 12; // days

  // Age distribution
  const age0to7 = Math.round(openIssues.length * 0.3);
  const age8to30 = Math.round(openIssues.length * 0.5);
  const age30plus = Math.round(openIssues.length * 0.2);

  const total = age0to7 + age8to30 + age30plus;

  return {
    averageAge,
    ageDistribution: [
      {
        label: "0-7 days",
        count: age0to7,
        percentage: (age0to7 / total) * 100,
        color: "bg-green-500",
      },
      {
        label: "8-30 days",
        count: age8to30,
        percentage: (age8to30 / total) * 100,
        color: "bg-yellow-500",
      },
      {
        label: "30+ days",
        count: age30plus,
        percentage: (age30plus / total) * 100,
        color: "bg-red-500",
      },
    ],
  };
})();
